import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaSearch } from "react-icons/fa";

interface IInput {
    comId: string;
    locale: string;
    onSubmit: (newSearch: string) => void;
    userRole?: string;
}

const Input = ({comId, locale = "en", onSubmit, userRole = "basic"}: IInput) => {
    // I18N
    const { t } = useTranslation();
    // SEARCH
    const [newSearch, setNewSearch] = useState("");

    const submit = () => {
        onSubmit(newSearch);
        setNewSearch('');
    };

    return (
        <div className="post_input_wrapper" >
            <div className="post_input_container" style={{height: '55px'}}>
                <textarea
                    value={newSearch}
                    onChange={(e) => setNewSearch(e.target.value)}
                    placeholder={t('worker.writeSearch')}
                    rows={1}
                    className="post_textArea"
                />
                <span onClick={submit} className="post_button">
                    <FaSearch size={20} />
                </span>
            </div>
        </div>
    );

};
export default Input;